/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutItemWrapSX } from '@/components/layouts/styles/itemWrap';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { Container, Grid, Paper, Stack } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { FC } from 'react';

export const IntertoysProductPageLayout_rv: FC<{ layout: Layout }> = ({ layout }) => {
    const {
		customDimensions: { layoutSpacing, pdpTopWidgetsSpacing }
	} = useTheme();
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
				<Stack
                    id="main-content"
					component="main"
					gap={layoutSpacing}
					sx={layoutMainSX(layout.slots.first?.length || 0)}
				>
					<Container component="section">
                        <Stack >
                            <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}>
                                <LayoutSlot slot={layout.slots.first} />
                            </Grid>
                        </Grid>
                        <Grid container columnSpacing={pdpTopWidgetsSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.second} /></Grid>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.third} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={pdpTopWidgetsSpacing}>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fourth} /></Grid>
                            <Grid item xs={12} sm={6} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifth} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.six} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seven} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eight} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.nine} /></Grid>
                        </Grid>
                        <Grid container columnSpacing={layoutSpacing}>
                            <Grid item xs={12} sm={12} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ten} /></Grid>
                        </Grid>
                        </Stack>
					</Container>
	    	</Stack>
            <LayoutSlot slot={layout.slots.footer} />
		</>
	) : null;
};